import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 10,
    alignItems: 'flex-end',
    backgroundColor: 'rgba(52, 52, 52, 0.4)', // needs a dedicated see-through color
  },
  menu: {
    width: '25%',
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadii.xl,
    margin: theme.spacings.sm,
  },
});
